// extracted by mini-css-extract-plugin
export default {"AppSpace":"AppSpace_AppSpace__H5Y8Y","imageViewer":"AppSpace_imageViewer__V3hVU","loading":"AppSpace_loading__EFp49"};